<template>
	<h1>Déconnexion</h1>
</template>

<script>
	import store from "../store";

	export default {
		name: "logout",
		mounted: async function () {

			if (
				store.state.user.rules &&
				store.state.user.rules.logout
			)
			window.location.href = store.state.user.rules.logout;
			
			var name = "login";
			if (
				(this.$store.state.user.details &&
					this.$store.state.user.details.client_uid) ||
				this.$store.state.adminSession
			)
				name = "login_admin";

			this.$store.commit("removeJwt");
			this.$store.commit("removeUser");
			this.$store.commit("removeClient");
			this.$store.commit("removeStyle");
			this.$store.commit("setAdminSession", false);
			this.$router.push({ name: name });
		},
	};
</script>
